import * as v from 'valibot';
import {
  setConfig,
  setLayout,
  useBaseStore,
  useConfigStore,
  useConnectionStore,
  useParticipantStore,
  type ConfigState,
} from '../store';
import { useTracksStore } from '../store/tracks';
import {
  InternalSettingSchema,
  type InternalSetting,
} from '../types/InternalSettingSchema';
import { safeParseJson } from './common';
import {
  CAMERA_FACING,
  CAMERA_FACING_INTERNAL,
  MEDIA_TYPE,
  VIDEO_PAUSE_AUTHORITY,
} from './constants';

// TODO: Remove this

export function updateConfig(config: Partial<ConfigState>) {
  setConfig(config);
  if (config.layout) {
    setLayout(config.layout);
  }
  console.log('updateConfig ::: ', config.internalSettings);
  if (typeof config.internalSettings === 'string') {
    const _internalSettings = safeParseJson<{ data: InternalSetting }>(
      config.internalSettings,
    );
    if (!_internalSettings?.data) {
      return;
    }
    const internalSettings = v.safeParse(
      InternalSettingSchema,
      _internalSettings.data,
    );
    if (internalSettings.success) {
      useParticipantStore.getState().updateLocalParticipant({
        name: internalSettings.output.user.name,
        avatar: internalSettings.output.user.avatar,
        uid: internalSettings.output.user.uid,
      });
      useConfigStore.setState({
        sessionId: internalSettings.output.sessionId,
      });
      useConnectionStore.setState({
        jwt: internalSettings.output.callToken,
      });
      useConnectionStore.setState({
        connectionConfig: internalSettings.output.settings.connectionConfig,
      });
    } else {
      console.error('Invalid internal setting data:', internalSettings.issues);
    }
  }
  if (config.devSessionId) {
    useConfigStore.setState({
      sessionId: config.devSessionId,
    });
  }
  if (config.initialCameraFacing) {
    useBaseStore.setState({
      cameraFacing:
        config.initialCameraFacing === CAMERA_FACING.REAR
          ? CAMERA_FACING_INTERNAL.ENVIRONMENT
          : CAMERA_FACING_INTERNAL.USER,
    });
  }
  if (config.displayName) {
    useParticipantStore.getState().updateLocalParticipant({
      name: config.displayName,
      avatar: undefined,
    });
  }
  if (typeof config.startAudioMuted === 'boolean') {
    useTracksStore.getState().updateLocalTrack(MEDIA_TYPE.AUDIO, {
      muted: config.startAudioMuted ? 1 : 0,
    });
  }
  if (typeof config.startVideoPaused === 'boolean') {
    useTracksStore.getState().updateLocalTrack(MEDIA_TYPE.VIDEO, {
      muted: config.startVideoPaused ? VIDEO_PAUSE_AUTHORITY.USER : 0,
    });
  }
  if (typeof config.enableNoiseReduction === 'boolean') {
    useBaseStore.setState({
      enableNoiseReduction: config.enableNoiseReduction,
    });
  }
}
